import ReportPage from './ReportPage'

export default function LojistasReport({className = ''}: {className?: string}) {
  return <ReportPage type='lojistas' className={className} />
}
